module.exports = __webpack_public_path__ + "static/img/Lindsay-Collins.f9bbe0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lindsay-Collins.jpg
// module id = Eowd
// module chunks = 0